export default {
    dependencies: ['$element'],
    callable(ele) {
        ele.addEventListener('click', _handleAnchorClick);
        function _handleAnchorClick(evt) {
            const a = evt.target.closest('a[id][href]');
            if (a && ele.contains(a)) {
                history.replaceState(window.history.state, null, `#${a.id}`);
            }
        }
    },
};



// WEBPACK FOOTER //
// ./controllers/streamIdAppend.js